<div class="u-flex-row u-flex-align-items-center u-border-radius-large u-padding-x-axis-half __status--{{ status }}">
    <app-icon [icon]="icon" *ngIf="icon" class="u-display-block u-margin-right-half"></app-icon>
    <p>{{ 'INVOICING.INVOICE.STATUS.' + status | upperSnakeCase | translate : { date: statusDate | formatDate } }}</p>
</div>
